import React from 'react';
import HomePage from '../components/HomeComponent/Home';

function Home() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default Home;
